// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1TeamSchema } from './v1/teamSchema';
import { v1TeamsCreateSchema } from './v1/teams/createSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const createTeamPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the team you want to create"),
});

export const createTeamHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Team
 */
export const createTeam201Schema = z.lazy(() => v1TeamSchema);

/**
 * @description Forbidden - Teams feature not enabled or insufficient permissions
 */
export const createTeam403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Unprocessable Entity
 */
export const createTeam422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const createTeamMutationRequestSchema = z.lazy(() => v1TeamsCreateSchema);

export const createTeamMutationResponseSchema = z.lazy(() => createTeam201Schema);
